import React from 'react';

import { flagStyles } from '../settings';

const SvgCD = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-912px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCD;
